module.exports = __webpack_public_path__ + "img/google-hangouts.ac7793ac.svg";